module.exports = __webpack_public_path__ + "img/banner03_info_business.5ef88db0.png";